module.exports = __webpack_public_path__ + "img/bd90198.png";